import config from '../config/config';

/**
 * Desen / sipariş gorsel_urls alanını temiz URL listesine çevirir.
 */
export const normalizeBaskiGorselUrls = (gorselUrls) => {
  if (!gorselUrls) return [];

  let urls = gorselUrls;
  if (typeof urls === 'string') {
    const trimmed = urls.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      urls = parsed;
    } catch {
      const matches = trimmed.match(/\/uploads\/[^"'\s,\]]+/g);
      if (matches?.length) {
        urls = matches;
      } else if (trimmed.startsWith('http') || trimmed.startsWith('/')) {
        urls = [trimmed];
      } else {
        return [];
      }
    }
  }

  if (!Array.isArray(urls)) {
    urls = [urls];
  }

  return urls
    .map((url) => {
      if (!url) return null;
      if (typeof url === 'object' && url.url) return String(url.url).trim();
      return String(url).replace(/^["']+|["']+$/g, '').trim();
    })
    .filter(Boolean);
};

export const resolveBaskiGorselUrl = (url) => {
  if (!url) return null;
  const clean = String(url).trim();
  if (!clean) return null;
  if (clean.startsWith('http://') || clean.startsWith('https://') || clean.startsWith('data:')) {
    return clean;
  }
  const path = clean.startsWith('/') ? clean : `/${clean}`;
  const base = (config.uploadsUrl || config.backendUrl || '').replace(/\/$/, '');
  return `${base}${path}`;
};

export const getFirstBaskiGorselUrl = (gorselUrls) => {
  const urls = normalizeBaskiGorselUrls(gorselUrls);
  return urls[0] || null;
};
